import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import HomeService from "../../../Services/HomeService";
import Swal from "sweetalert2";
import toast from "react-hot-toast";

const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "#868e96",
    margin: "15px",
    fontWeight: "bold",
};

function ManageBhk() {
    const [bhks, setBhks] = useState([]);
    const [loading, setLoading] = useState(false);
    const [bhkID, setBhkID] = useState("");
    const [isEdit, setIsEdit] = useState(false);
    const [editData, setEditData] = useState({ bhk: "" });

    const columns = [
        { name: "S.No.", selector: (row) => row.sln, sortable: true },
        { name: "BHK", selector: (row) => row.bhk, sortable: true },
        {
            name: "Action",
            cell: (row) => (
                <>
                    <span title="Edit" onClick={() => handleEdit(row)}>
                        <i
                            className="fa-solid fa-pen-to-square"
                            style={{
                                cursor: "pointer",
                                padding: "5px",
                                marginRight: "5px",
                                fontSize: "1.5em",
                                color: "#477DA5",
                                backgroundColor: "#E9F3F7",
                            }}
                        ></i>
                    </span>
                    <span title="Delete" onClick={() => handleDelete(row.id)}>
                        <i
                            className="fa-solid fa-trash-can"
                            style={{
                                cursor: "pointer",
                                padding: "5px",
                                marginRight: "5px",
                                fontSize: "1.5em",
                                color: "#477DA5",
                                backgroundColor: "#E9F3F7",
                            }}
                        ></i>
                    </span>
                </>
            ),
        },
    ];

    const fetchAllBhks = async () => {
        setLoading(true);
        try {
            const res = await HomeService.getBhks();
            const arr = res?.data?.map((ele, ind) => ({
                sln: ind + 1,
                bhk: ele.bhk,
                id: ele._id,
            }));
            setBhks(arr);
        } catch (error) {
            console.error("Error fetching BHKs:", error);
            toast.error("Failed to load BHKs!");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAllBhks();
    }, []);

    const handleEdit = (row) => {
        setIsEdit(true);
        setEditData({ bhk: row.bhk });
        setBhkID(row.id);
    };

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: "Delete BHK?",
            text: "Are you sure you want to delete this BHK?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            confirmButtonColor: "#d33",
            cancelButtonText: "Cancel",
            reverseButtons: true,
        });
        if (result.isConfirmed) {
            try {
                await HomeService.deleteBhk(id);
                Swal.fire("Deleted!", "BHK has been deleted.", "success");
                fetchAllBhks();
            } catch (error) {
                Swal.fire("Error!", "Failed to delete BHK.", "error");
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const data = { bhk: editData.bhk };
            if (isEdit) {
                await HomeService.updateBhk(bhkID, data);
                toast.success("BHK updated successfully!");
            }
            setIsEdit(false);
            setEditData({ bhk: "" });
            fetchAllBhks();
        } catch (error) {
            toast.error("Failed to save BHK.");
            console.error("Error saving BHK:", error);
        }
    };

    return (
        <>
            <div className="main_wrap" style={{ marginTop: "6rem" }}>
                <div className="container-fluid">
                    {isEdit && (
                        <section className="chartBox_area">
                            <h2>Edit BHK</h2>
                            <hr />
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-md-6 mt-3">
                                        <label htmlFor="bhk">
                                            BHK<span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="bhk"
                                            className="form-control"
                                            value={editData.bhk}
                                            onChange={(e) =>
                                                setEditData({ ...editData, bhk: e.target.value })
                                            }
                                            placeholder="Enter BHK"
                                            required
                                        />
                                    </div>
                                </div>
                                <button type="submit" className="btn btn-primary mt-3">
                                    Save Changes
                                </button>
                            </form>
                        </section>
                    )}

                    <div className="mt-5">
                        <div style={headLineStyle} className="page-headline">
                            Manage BHKs
                        </div>
                        {loading ? (
                            <p>Loading...</p>
                        ) : (
                            <DataTable
                                columns={columns}
                                data={bhks}
                                pagination
                                responsive
                                highlightOnHover
                            />
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default ManageBhk;
